import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { ListViewModule } from 'src/app/shared/list/list-view/list-view.module';
import { TextfieldComponent } from 'src/app/shared/form/textfield/textfield.component';
import { InteractiveActivitiesListComponent } from './interactive-activities-list.component';
import { ListToolbarModule } from 'src/app/shared/list/list-toolbar/list-toolbar.module';
import { ListPaginatorModule } from 'src/app/shared/list/list-paginator/list-paginator.module';
import { CopyToClipboardModule } from 'src/app/shared/copy-to-clipboard/copy-to-clipboard.module';
import { InteractiveActivityTypesComponent } from '../IA-types/interactive-activity-types.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    SpinnerModule,
    ListViewModule,
    TextfieldComponent,
    ListToolbarModule,
    ListPaginatorModule,
    CopyToClipboardModule,
    InteractiveActivitiesListComponent,
    InteractiveActivityTypesComponent,
  ],
})
export class InteractiveActivitiesListModule {}
